// Navigation umschalten in mobile Style wenn zu breit
function navbarCollapse() {
	if ($(window).width() >= 768) {
		var mainwidth = $('.primary-nav .container-fluid').innerWidth();
		var logowidth = $('.navbar-brand').innerWidth();
		var buttonwidth = $('.primary-nav .btn-primary').innerWidth();
		var navwidth = $('.navbar-nav').innerWidth();
		var searchwidth = $('.search-holder .form-control').innerWidth();
		var controlwidth = mainwidth - logowidth - buttonwidth;
		var semimobilewidth = navwidth + searchwidth + 100;
		var mobilewidth = navwidth + 100;

		if (controlwidth < mobilewidth) {
			$('.primary-nav').removeClass('search-simple');
			if (!$('.primary-nav').hasClass('navbar-mobile')) {
				$('.primary-nav').addClass('navbar-mobile');
			}
		} else if (controlwidth < semimobilewidth && controlwidth > mobilewidth) {
			$('.primary-nav').removeClass('navbar-mobile');
			if (!$('.primary-nav').hasClass('search-simple')) {
				$('.primary-nav').addClass('search-simple');
			}
		} else {
			$('.primary-nav').removeClass('search-simple');
			$('.primary-nav').removeClass('navbar-mobile');
		}
	} else {
		if (!$('.primary-nav').hasClass('navbar-mobile')) {
			$('.primary-nav').addClass('navbar-mobile');
		}
	}
}

// Funktion zur Positionierung des Searchlayer mittig zum Inputfeld im Header
function positionsearchlayer() {
	$('.searchlayer').css('top', $('.opensearchlayer').offset().top + 20);
	$('.searchlayer').css('left', $('.opensearchlayer').offset().left + $('.opensearchlayer').width() / 2);
}


// Funktion Produkttabelle
function producctable(toggle) {
	var thistoggle = toggle;
	var target = thistoggle.parents('.fixedsection');
	if ($(window).innerWidth() <= 768) {
		target.find('.toggleunit').removeClass('active');
		thistoggle.addClass('active');
		if (thistoggle.data('target') == "show-mm") {
			target.removeClass('unitzoll');
			target.addClass('unitmm');
			target.find('tbody tr td:first-child').attr('colspan', 2);
			target.find('tbody tr td:last-child').attr('colspan', 1);
		} else {
			target.removeClass('unitmm');
			target.addClass('unitzoll');
			target.find('tbody tr td:first-child').attr('colspan', 1);
			target.find('tbody tr td:last-child').attr('colspan', 2);
		}
	} else {
		target.removeClass('unitmm, unitzoll')

	}
};

function producctableresize() {
	if ($(window).outerWidth() <= 767) {
		$('.fixedsection tbody tr td:first-child').attr('colspan', 2);
		$('.fixedsection').addClass('unitmm');
		$('tr .toggleunit:first').addClass("active");
		$('.producttable .scrollsection').on('touchstart click', function() {
			$(this).addClass('hover');
		});
	} else {
		$('.fixedsection tbody tr td').attr('colspan', 1);
		$('.fixedsection').removeClass('unitmm, unitzoll');
		$('tr .toggleunit').removeClass("active");
	}
};

//Tabelle mobile Scrollindikator
function tableindicator() {
	$('.table-scroll-indicator').each(function() {
		if ($(this).width() < $(this).find('table').width()) {
			$(this).addClass('scroll');
		} else {
			$(this).removeClass('scroll');
		}
	});
	$('.table-scroll-indicator.scroll').on('touchstart click', function() {
		$(this).addClass('hover');
	});
}
// Fix VH IOS safari
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);


$(document).ready(function() {

	//Slider Warum Wikus

	$('.ww-slider .slides')
		.on('afterChange init', function(event, slick, currentSlide, nextSlide) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');

			for (var i = 0; i < slick.$slides.length; i++) {
				var $slide = $(slick.$slides[i]);
				var $lastslide = $(slick.$slides[slick.$slides.length - 1]);

				if ($slide.hasClass('slick-current')) {
					// update DOM siblings
					$slide.prev().addClass('prevdiv');
					if (!$lastslide.hasClass('slick-active')) {
						$lastslide.addClass('nextdiv');
					}
					//$slide.next().addClass('nextdiv');
					//alert(slick.$slides.length-1);
					break;
				}
			}
			slick.$slides.each(function() {
				if (!$(this).hasClass('slick-active') && !$(this).hasClass('prevdiv')) {
					$(this).addClass('nextdiv')
				}
			});
		})
		.on('beforeChange', function(event, slick) {
			//slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');
		})

	$('.ww-slider .slides').slick({
		dots: false,
		arrows: false,
		infinite: false,
		speed: 200,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		mobileFirst: true,
		rows: 0,
		responsive: [{
				breakpoint: 560,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});
	$(document).on('click', '.ww-slider .nextdiv', function() {
		$(this).closest('.ww-slider .slides').slick("slickNext");
		return false;
	});
	$(document).on('click', '.ww-slider .prevdiv', function() {
		$(this).closest('.ww-slider .slides').slick("slickPrev");
		return false;
	});

	//Slider Bildslider (M05 Slidermodul)
	$('.ps-slider ')
		.on('afterChange init', function(event, slick, currentSlide, nextSlide) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');
			for (var i = 0; i < slick.$slides.length; i++) {
				var $slide = $(slick.$slides[i]);
				var $lastslide = $(slick.$slides[slick.$slides.length - 1]);

				if ($slide.hasClass('slick-current')) {
					// update DOM siblings
					$slide.prev().addClass('prevdiv');
					if (!$lastslide.hasClass('slick-active')) {
						$lastslide.addClass('nextdiv');
					}
					//$slide.next().addClass('nextdiv');
					//alert(slick.$slides.length-1);
					break;
				}
			}

			slick.$slides.each(function() {
				if (!$(this).hasClass('slick-active') && !$(this).hasClass('prevdiv')) {
					$(this).addClass('nextdiv')
				}
			});



		})
		.on('beforeChange', function(event, slick) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');
		})

		.slick({
			dots: false,
			arrows: true,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			rows: 0,
			cssEase: 'ease-in',
			prevArrow: $('.picturesilder .slick-prev'),
			nextArrow: $('.picturesilder .slick-next'),
			responsive: [{
				breakpoint: 560,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}, {
				breakpoint: 1023,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}]
		});

	// Slider Bildslider Pfeile erst on hover anzeigen
	$(document).on('mouseover', '.picturesilder .slick-slide', function() {
		var parent = $(this).closest('section');
		if ($(this).hasClass('prevdiv')) {
			parent.find('.slick-prev').css('top', ($('.picturesilder .slick-slide img').height() / 2) - 24);
			parent.find('.slick-prev').addClass('active');
		} else if ($(this).hasClass('nextdiv')) {
			parent.find('.slick-next').css('top', ($('.picturesilder .slick-slide img').height() / 2) - 24);
			parent.find('.slick-next').addClass('active');
		}
	}).on('mouseout', '.picturesilder .slick-slide', function() {
		var parent = $(this).closest('section');
		parent.find('.slick-arrow').removeClass('active');
	});

	$(".picturesilder .slick-prev").hover(function() {
		$(".ps-slider .prevdiv").addClass('hover');
	}, function() {
		$(".ps-slider .prevdiv").removeClass('hover');
	});
	$(".picturesilder .slick-next").hover(function() {
		$(".ps-slider .nextdiv").addClass('hover');
	}, function() {
		$(".ps-slider .nextdiv").removeClass('hover');
	});
	$(document).on('click', '.ps-slider .nextdiv', function() {
		$(this).closest('.ps-slider').slick("slickNext");
		return false;
	});
	$(document).on('click', '.ps-slider .prevdiv', function() {
		$(this).closest('.ps-slider').slick("slickPrev");
		return false;
	});





	//Hero Slider (M09 Storybanner)
	$('.heropictureslider .slides')
		.on('afterChange init', function(event, slick, currentSlide, nextSlide) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');

			for (var i = 0; i < slick.$slides.length; i++) {
				var $slide = $(slick.$slides[i]);
				var $lastslide = $(slick.$slides[slick.$slides.length - 1]);

				if ($slide.hasClass('slick-current')) {
					// update DOM siblings
					$slide.prev().addClass('prevdiv');
					if (!$lastslide.hasClass('slick-active')) {
						$lastslide.addClass('nextdiv');
					}
					//$slide.next().addClass('nextdiv');
					//alert(slick.$slides.length-1);
					break;
				}
			}
			slick.$slides.each(function() {
				if (!$(this).hasClass('slick-active') && !$(this).hasClass('prevdiv')) {
					$(this).addClass('nextdiv')
				}
			});
			if (slick.$slides.length <= 1) {
				$(this).addClass('single')
			}
		})
		.on('beforeChange', function(event, slick) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			slick.$slides.removeClass('hover');
		})
	$(".heropictureslider .slides").slick({
		// asNavFor: '.heropictureslider .captions',
		asNavFor: '.heropictureslider .backs',
		infinite: false,
		speed: 400,
		arrows: false,
		fade: false,
		mobileFirst: true,
		rows: 0,
		responsive: [{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
			}
		}]
	});
	$(document).on('click', '.heropictureslider .nextdiv', function() {
		$(this).closest('.heropictureslider .slides').slick("slickNext");
		return false;
	});
	$(document).on('click', '.heropictureslider .prevdiv', function() {
		$(this).closest('.heropictureslider .slides').slick("slickPrev");
		return false;
	});





	//Hero Slider Caption
	$(".heropictureslider .captions").slick({
		asNavFor: '.heropictureslider .slides',
		infinite: false,
		speed: 400,
		fade: true,
		arrows: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		rows: 0,
		focusOnSelect: true
	});
	//Hero Slider geblurter mobiler Hintergrund
	$(".heropictureslider .backs").slick({
		asNavFor: '.heropictureslider .captions',
		infinite: false,
		speed: 400,
		fade: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 0,
		focusOnSelect: true
	});

	//Content Gallery Slider (M14 Bildslider)
	$(".gallery .col")
		.on('afterChange init', function(event, slick, direction) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			for (var i = 0; i < slick.$slides.length; i++) {
				var $slide = $(slick.$slides[i]);
				if ($slide.hasClass('slick-current')) {
					// update DOM siblings
					$slide.prev().addClass('prevdiv');
					$slide.next().addClass('nextdiv');
					break;
				}
			}
		})
		.on('beforeChange', function(event, slick) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
		})
		.slick({
			infinite: false,
			speed: 400,
			arrows: true,
			fade: false,
			mobileFirst: true,
			centerMode: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: 0,
			rows: 0,
			prevArrow: $('.gallery .prev'),
			nextArrow: $('.gallery .next')
		});
	$(document).on('mouseover', '.gallery .slick-slide', function() {
		var parent = $(this).parents('section.gallery');
		if ($(this).hasClass('prevdiv')) {
			parent.find('button.prev').css('top', ($(this).find('img').height() - 28) / 2);
			parent.find('button.prev').addClass('active');
		} else if ($(this).hasClass('nextdiv')) {
			parent.find('button.next').css('top', ($(this).find('img').height() - 28) / 2);
			parent.find('button.next').addClass('active');
		}
	}).on('mouseout', '.gallery .slick-slide', function() {
		var parent = $(this).parents('section.gallery');
		parent.find('button').removeClass('active');
	});

	$(document).on('click', '.gallery .nextdiv', function() {
		$(".gallery .col").slick("slickNext");
	});
	$(document).on('click', '.gallery .prevdiv', function() {
		$(".gallery .col").slick("slickPrev");
	});

	//Quotes Slider (M15 Quotes)

	/*
    var $statusCheck = $('.quote .pagingInfo');
    var $slickElementCheck = $('.quote .col');

    $slickElementCheck.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $statusCheck.text(i + '/' + slick.slideCount);
    });
*/



	$(".quote .slides")
		.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			if (slick.slideCount > 1) {
				$(this).parent().find('.pagingInfo').text(i + '/' + slick.slideCount);
			} else {
				$(this).addClass('single');
				$(this).closest('.row').addClass('singlequote');
                $(this).closest('.quote').find('button').remove(); //remove arrows
			}
		})
		.on('afterChange init', function(event, slick, direction) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
			for (var i = 0; i < slick.$slides.length; i++) {
				var $slide = $(slick.$slides[i]);
				if ($slide.hasClass('slick-current')) {
					// update DOM siblings
					$slide.prev().addClass('prevdiv');
					$slide.next().addClass('nextdiv');
					break;
				}
			}
		})
		.on('beforeChange', function(event, slick) {
			slick.$slides.removeClass('prevdiv').removeClass('nextdiv');
		})
		.slick({
			infinite: false,
			speed: 400,
			arrows: true,
			fade: false,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: 0,
			rows: 0,
			centerMode: false,
			prevArrow: $('.quote .prev'),
			nextArrow: $('.quote .next')
            // appendArrows: '.quote'
		});
	$(document).on('mouseover', '.quote .slick-slide', function() {
		var parent = $(this).parents('section.quote');
		if ($(this).hasClass('prevdiv')) {
			parent.find('button.prev').addClass('active');

		} else if ($(this).hasClass('nextdiv')) {
			parent.find('button.next').addClass('active');
		}
	}).on('mouseout', '.quote .slick-slide', function() {
		var parent = $(this).parents('section.quote');
		parent.find('button').removeClass('active');
	});
    // Slide-items to navigate only current slider
	$(document).on('click', '.quote .nextdiv', function() {
		$(this).closest('.quote').find(".slides").slick("slickNext");
	});
	$(document).on('click', '.quote .prevdiv', function() {
		$(this).closest('.quote').find(".slides").slick("slickPrev");
	});
    // Arrow to navigate only current slider
    $(document).on('click', '.quote .next', function() {
		$(this).closest('.quote').find(".slides").slick("slickNext");
	});
	$(document).on('click', '.quote .prev', function() {
		$(this).closest('.quote').find(".slides").slick("slickPrev");
	});



	// News Funktionen
	$('.yearPicker .year').on('change', function() {
		$('form.yearPicker').submit();
	});

	// Facts Slider
	$(".facts .slides").slick({
		infinite: false,
		speed: 400,
		arrows: false,
		dots: true,
		fade: false,
		mobileFirst: true,
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		appendDots: $(this).find('.Slick-Navigation'),
		responsive: [{
			breakpoint: 560,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		}, {
			breakpoint: 1024,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4,
			}
		}]
	});


	// Slider related Products
	$(".relatedproduct .slides").slick({
		infinite: false,
		speed: 400,
		arrows: false,
		dots: false,
		fade: false,
		mobileFirst: true,
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		//appendDots:$(this).find('.Slick-Navigation'),
		responsive: [{
			breakpoint: 560,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			}
		}, {
			breakpoint: 767,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			}
		}, {
			breakpoint: 1023,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 1,
			}
		}]
	});







	// zu mobiler Navigation wechseln wenn kein Platz mehr
	navbarCollapse();

	$(document).on('click', '.closelayer', function() {
		$('body').removeClass('layeropen');
		//$('.searchlayer .result').fadeOut(400);
		$('.fadelayer').fadeOut(400);
	});

	//Suchlayer: Klick auf häufige Suchanfragen stößt Suche an
	$(document).on("click", ".solr-frequent-term", function() {
		var $form = $(this).closest('form');
		$form.find('.tx-solr-suggest').val($(this).text());
		$form.submit();
	});

	// Diverse Layer einfaden
	$(document).on('click', '.openlayer:not(.disabled)', function() {
		$('body').addClass('layeropen');

		// Ticket 160 - Umbau für Klasse und ID sowie return false für Links
		let target = $(this).data('target');
		if (target.indexOf("#") >= 0) {
			$($(this).data('target')).fadeIn(400);
		} else {
			$('.' + $(this).data('target')).fadeIn(400);
		}

    $('.headerSearch input.form-control').focus();

		return false;

		if ($('.searchlayer:visible').find('[data-suggest]')) {
			$('.searchlayer:visible').find('[data-suggest]').val('');
			$('.searchlayer input').focus();
		}

		if ($(this).data('focus')) {
			if ($('input#' + $(this).data('focus')).length > 0) {
				$('input#' + $(this).data('focus')).focus();
			}
		}
		$('.searchlayer .result').show();
	});
	//Verhindern, dass in Textfelder die als openlayer Trigger funktionieren sollen Text geschrieben werden kann
	jQuery('input.openlayer').on('focus', function() {
		$(this).blur();
	});

	// Tabs Produktdetailseite
	$('#myTab a').on('click', function(e) {
		e.preventDefault();
		$(this).tab('show');
	})


	// Produkttabelle
	$('.producttable .toggleunit').on('click', function() {
		producctable($(this));
	});
	producctableresize();

	//Floating Label
	initFloatingLabels();

	//Tabelle mobile Scrollindikator
	tableindicator();

	//Cookiecheck
	$(document).on('click', '#cookiecheck', function() {
		$(this).toggleClass('decline');
		if ($(this).hasClass('decline')) {
			p.setStatus(cookieconsent.status.deny);
		} else {
			p.setStatus(cookieconsent.status.allow);
		}
	});
	//Klick auf Cookie-Einstellungen setzt consent auf dismiss
	$('.deny-consent').on('click', function(e) {
		p.setStatus(cookieconsent.status.deny);
	});


	// Mobiles Menü
	$(document).on('click', '.mobileback', function() {
		$(this).closest('li.dropdown').find('.dropdown-toggle').trigger("click");
	});
	$(document).on('click', 'body', function(e) {
		if (!$(e.target).is('header')) {
			e.stopPropagation();
		} else {
			$(".navbar-toggler").trigger("click");
		}
	});

	//Klasse header bei offenem Meü wegen Seitenabdunklung
	$(document).on('click', '.navbar-toggler', function() {
		if ($(this).hasClass('collapsed')) {
			$('html').removeClass('menuopen');
			$('html').addClass('menuclose');
		} else {
			$('html').addClass('menuopen');
			$('html').removeClass('menuclose');
		}
	});

	//Smooth Öffnen/Schließen Submenüs Desktop // Klasse thridlevel setzen wenn 3. Ebene geöffnet wird
	$(document).on("show.bs.dropdown", ".dropdown", function(event) {
		if (!$('.primary-nav').hasClass('navbar-mobile')) {
			$(event.target).find(">.dropdown-menu:first").fadeIn(100);
		} else {
			$('.navbar-holder').addClass('thirdlevel');
		};
	});
	$(document).on("hide.bs.dropdown", ".dropdown", function(event) {
		if (!$('.primary-nav').hasClass('navbar-mobile')) {
			$(event.target).find(">.dropdown-menu:first").fadeOut(100);
		} else {
			$('.navbar-holder').removeClass('thirdlevel');
		};
	});



	// Anzahl Teaser ermitteln und wenn kleiner als die Angabe im Typo zentrieren
	$('.row.teaser-items').each(function() {
		if ($(this).data('count') > $(this).find('.col').length) {
			$(this).addClass('justify-content-center');
		}
	});

	// Letztem element in Main und Contentholder Klasse last geben
	$('main').find('section:last').addClass('last');
	$('.contentholder').find('.last').removeClass('last');


});

function initFloatingLabels() {
	$('.floatingfield input, .floatingfield textarea, .floatingfield select').on('focus blur', function(e) {
		$(this).parents('.floatingfield').toggleClass('is-focused', (e.type === 'focus' || this.value.length > 0));
	}).trigger('blur');
}

(function() {
	var resizedTimeout;

	function fireResized() {
		$(window).trigger("resized");
	}

	function checkResized() {
		window.clearTimeout(resizedTimeout);
		resizedTimeout = window.setTimeout(fireResized, 150);
	}

	function updateUnittypesByCookieVal(cookieVal){
		if(cookieVal == 2){
			document.querySelectorAll('.isImperial').forEach(function(elem){
				elem.classList.remove('verteckt');
			});
			document.querySelectorAll('.isMetric').forEach(function(elem){
				elem.classList.add('verteckt');
			});
		}
		else {
			document.querySelectorAll('.isImperial').forEach(function(elem){
				elem.classList.add('verteckt');
			});
			document.querySelectorAll('.isMetric').forEach(function(elem){
				elem.classList.remove('verteckt');
			});
		}
	}

	$(window).on("resize", checkResized).on("orientationchange", fireResized);

	var metricImperialSwitch = document.querySelectorAll('.js-metricswitch');
	var cookieStringSet = document.cookie
		.split('; ')
		.find(row => row.startsWith('Bandsaw_UNIT='));
	if(cookieStringSet){
		var currentCookieVal = cookieStringSet.split('=')[1];
	}
	updateUnittypesByCookieVal(currentCookieVal);
	metricImperialSwitch.forEach(function(switchelem){
		var switchCheckbox = switchelem.querySelector('input');
		if(currentCookieVal == 2 && switchCheckbox.checked === false ){-
			switchCheckbox.click();
		}
		switchCheckbox.addEventListener('change', function(){
			var newCookieVal = 0;
			if(switchCheckbox.checked){
				newCookieVal = 2;
			}
			else {
				newCookieVal = 1;
			}
			updateUnittypesByCookieVal(newCookieVal);
			var request = new XMLHttpRequest();
			request.open('GET', '/api/bandsawbladeajax?unittype='+newCookieVal, true);
			request.onload = function() {
				if (this.status >= 200 && this.status < 400) {
					// Success!
					var resp = this.response;
				}
			};
			request.onerror = function() {
				// There was a connection error of some sort
			};
			request.send();
		});
	});
})();

// all content including images has been loaded
window.onload = function() {
	if($('body.iframe').length){
		// post our message to the parent
		window.parent.postMessage(
			// get height of the content
			document.body.scrollHeight
			// set target domain
			,"*"
		)
	}
};


if($('#notification-popup').length > 0){
	if (!$.cookie("notice-accepted")) {
		$.magnificPopup.open({
			items: {
				src: '#notification-popup',
				type: 'inline'
			},
			callbacks: {
				open: function() {
					$.magnificPopup.instance.close = function() {
						$.cookie("notice-accepted", 1, { expires : 365 });
						$.magnificPopup.proto.close.call(this);
					};
				}
			}
		});
	}
}

$(window).on("resized", function() {
	var w = $(window).width();
	if (typeof checkw == 'undefined') checkw = w;
	if (w != checkw) {
		//Slider Warum Wikus
		//initializeWarumWikusSlider();
		navbarCollapse();
		//positionsearchlayer();
		producctableresize();
		tableindicator();
		$('html').removeClass('menuopen menuclose');
		$('.navbar-collapse').removeClass('show');
		$('.navbar-toggler').addClass('collapsed');
		$('.navbar-toggler').attr('aria-expanded', 'false');
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
		checkw = w;
	}
});

// Tooltip
$(function () {
	var pos = ($(window).width() < 768) ? 'bottom' : 'auto';
	$('[data-toggle="tooltip"]').tooltip({'placement': pos});
})

// Sortable
$(function () {
	$('#sort').on('change', function () {
		if ($(this).val() == "sortDate") {
			sortDate();
		} else if ($(this).val() == "sortName") {
			sortName();
		} else if ($(this).val() == "sortCat") {
            if(getCookie('sorting') !== 'sortCat' ) {
                sortCat();
            }
		} else if ($(this).val() == "sortDragDrop") {
			sortDragDrop();
		}

        sortCookie($(this).val());
	});
});

/**
 * Sort the cookie depending on frontend
 * @param sorting
 */
function sortCookie(sorting = "") {
    let value = '';
    $('.bookmark-item').each(function () {
        if(value === '') {
            value = $(this).attr('data-id');
        } else {
            value = value + ',' + $(this).attr('data-id');
        }
    });

    if(sorting) {
        setCookie('sorting', sorting);
    }
    setCookie('bookmarks', value);
}

// Sortables
function sortDate() {
	var list = $('#sortable');
	list.children().sort(function(a,b) {
		var getdat = function(el){return new Date( $(el).data('date'))};
		return getdat(a) - getdat(b);
	}).appendTo(list);
	$('#sortable').find('.categorie').remove();
	$('#sortable').find('.card').attr('draggable',false);
};
function sortName() {
	var sortableList = $('#sortable');
	var listitems = $('.bookmark-item', sortableList);
	listitems.sort(function (a, b) {
		return ($(a).data('name').toUpperCase() > $(b).data('name').toUpperCase())  ? 1 : -1;
	});
	sortableList.append(listitems);
	$('#sortable').find('.categorie').remove();
	$('#sortable').find('.card').attr('draggable',false);
};
function sortCat() {
	var sortableList = $('#sortable');

    var valueList = {};
    $('.bookmark-item').each(function () {
        valueList[$(this).attr('data-cat')] = $(this).attr('data-sorting');
    });

	var listitems = $('.bookmark-item', sortableList);

    listitems.sort(function (a, b) {
        return ( valueList[$(a).data('cat')] > valueList[$(b).data('cat')])  ? 1 : -1;
    });

	sortableList.append(listitems);
	var cat = "";
	$('.bookmark-item').each(function() {
		if ($(this).data('cat') != cat) {
			cat = $(this).data('cat');
			$( '<div class="categorie">'+cat+'</div>').insertBefore($(this));
		}
	});
	$('#sortable').find('.card').attr('draggable',false);
};
function sortDragDrop() {
	sortable('.sortable', {
		forcePlaceholderSize: true,
		placeholderClass: 'ph-class',
		hoverClass: 'ph-hover',
	});
	$('#sortable').find('.categorie').remove();
};

// Remove item from Bookmarklist
$(document).on('click', '.bookmark-item .delete', function(){
    let productId = $(this).attr('data-id');
    removeFromBookmarks(productId);
	$(this).parent().remove();
});

// Bookmarklink on Product Cards
$(document).on('click', '.link-merkliste-add', function(){
	$('.modal-merkliste').removeClass('active');
    let productId = $(this).parent().attr('data-id');
	if($(this).hasClass('active')) {
		$(this).removeClass('active');
        removeFromBookmarks(productId);
		$('#modal-bookmark-remove').find('.dynTitle').html($(this).parent().find('.card-title').html());
		if($(this).parents('.productstage').length > 0) {
			$('#modal-bookmark-remove').find('.dynTitle').html($(this).parents('.productstage').find('.h1').html());
		}
		setTimeout(function() {
			$('#modal-bookmark-remove').addClass('active');
			setTimeout(function() {
				$('#modal-bookmark-remove').removeClass('active');
			}, 6000);
		}, 500);
	} else {
		$(this).addClass('active');
        addToBookmarks(productId)
		$('#modal-bookmark-add').find('.dynTitle').html($(this).parent().find('.card-title').html());
		if($(this).parents('.productstage').length > 0) {
			$('#modal-bookmark-add').find('.dynTitle').html($(this).parents('.productstage').find('.h1').html());
		}
		setTimeout(function() {
			$('#modal-bookmark-add').addClass('active');
			setTimeout(function() {
				$('#modal-bookmark-add').removeClass('active');
			}, 6000);
		}, 500);
	}
});

// Close Bookmarkmoal
$(document).on('click', '.modal-merkliste .closemod', function(){
	$(this).parents('.modal-merkliste').removeClass('active');
});
